import {CommonModule} from '@angular/common';
import {Component, inject, input} from '@angular/core';
import {PopoverModule} from 'primeng/popover';
import {
  AVAILABLE_FILTERS_SOURCES,
  isBestPriceFilter,
  isCategoryFilter,
  isDaysValueFilter,
  isFetchStatusFilter,
  isLogicalConditionFilter,
  isMostUsedPriceFilter,
  isOutliersFilter,
  isPriceChangesFilter,
  isProductPerformanceFilter,
  isWithCompetitorsFilter,
  ProductGroupFilterEntity,
} from '@em/data-feed/util-types';
import {
  ConditionalStatementList,
  LogicalOperator,
} from '@em/shared/mapping-engine/domain-models';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'em-readable-filters',
  templateUrl: './readable-filters.component.html',
  styleUrls: ['./readable-filters.component.scss'],
  imports: [CommonModule, TranslateModule, PopoverModule, MatIconModule],
})
export class EmReadableFiltersComponent {
  private readonly _translateService = inject(TranslateService);
  filters = input<ConditionalStatementList<ProductGroupFilterEntity>>();

  isLogicalConditionFilter = isLogicalConditionFilter;
  isCategoryFilter = isCategoryFilter;
  isBestPriceFilter = isBestPriceFilter;
  isMostUsedPriceFilter = isMostUsedPriceFilter;
  isPriceChangesFilter = isPriceChangesFilter;
  isFetchStatusFilter = isFetchStatusFilter;
  isOutliersFilter = isOutliersFilter;
  isDaysValueFilter = isDaysValueFilter;
  isWithCompetitorsFilter = isWithCompetitorsFilter;
  isProductPerformanceFilter = isProductPerformanceFilter;

  getGroupClass(
    currentOperator: LogicalOperator | null | undefined,
    parentOperator: LogicalOperator | null | undefined,
  ) {
    if (currentOperator) {
      return 'logic-group--' + currentOperator.toLowerCase();
    } else if (parentOperator) {
      if (parentOperator === 'and') {
        return 'logic-group--or';
      } else {
        return 'logic-group--and';
      }
    }
    return '';
  }

  getKeyDisplayName(key: string) {
    return this._translateService.instant('COLUMN_' + key.toUpperCase());
  }

  getSrouceName(key: string) {
    return (
      AVAILABLE_FILTERS_SOURCES.find((source) => source.id === key)?.name || key
    );
  }
}
